<template>
  <div class="jl-a-d-rbox7">
    <p class="rb7-title">最新出价</p>
    <div class="rb7-table-wrap">
      <table class="rb7-table">
        <thead>
          <tr>
            <th>状态</th>
            <th>竞拍人</th>
            <th>出价金额</th>
            <th>出价时间</th>
          </tr>
        </thead>
      </table>
      <div>
        <div class="jl-last-noinfo" v-if="recordList.length ==  0">
          <p class="text-no-t">暂无记录</p>
        </div>
        <table class="rb7-table">
          <tbody>
            <template v-for="(item, index) in recordList">
              <tr :key="item.id" v-if="index < 3">
                <td>
                  <p
                    :class="[index === 0?'text1 rb7-td1 color-e5':'text1 rb7-td1 color-ccc']"
                  >{{index === 0?'领先':'出局'}}</p>
                </td>
                <td>
                  <p :class="[index === 0?'text1 color-e5':'text1']">{{item.frontUser.userName}}</p>
                </td>
                <td>
                  <p :class="[index === 0?'text1 color-e5':'text1']">¥ {{item.bidPrice}}</p>
                </td>
                <td>
                  <p :class="[index === 0?'text1 color-e5':'text1 color-ccc']">{{item.bidDate}}</p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordList: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-last-noinfo {
  text-align: center;
  .text-no-t {
    font-size: 14px;
    color: #ccc;
    margin-top: 30px;
  }
}
.jl-a-d-rbox7 {
  .rb7-title {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    margin-bottom: 14px;
  }
  .rb7-table {
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    thead {
      background-color: #f8f8fb;
    }
    th,
    td {
      width: 25%;
      padding: 11px 16px;
      font-size: 14px;
      color: #333;
      text-align: center;
      &:first-child {
        text-align: left;
      }
    }
    td {
      font-size: 14px;
      color: #666;
      text-align: center;
      padding: 7px 0;
      .color-e5 {
        color: #e50011;
      }
      .color-ccc {
        color: #ccc;
      }
      &:first-child {
        text-align: left;
        padding-left: 10px;
      }
      .rb7-td1 {
        position: relative;
        padding-left: 14px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          margin-top: -4px;
          background-color: #ccc;
        }
        &.color-e5::before {
          background-color: #e50011;
        }
      }
    }
  }
}
</style>
